import { axiosProxy } from '@utils/axios'

// Подтверждение показа инфо-модалки о возобновлении синхронизации.
// Тело пустое — действие по текущему проекту (заголовок Evirma-Project ставит axiosProxy). Идемпотентно.
export const ackPauseNoticeRequest = () => axiosProxy.post('/project/pause-notice/ack', {})
